<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro">
      <input
        :type="type || 'text'"
        class="form-input"
        v-model="info.value"
        @change="info.resetValue()"
        :disabled="info.disabled"
        placeholder="请填写"
      />
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SText",
  props: {
    info: {},
    type: null
  }
};
</script>

<style scoped></style>
